import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import { ArrowRight, SimpleImage, Typography, UserIcon, VideoCameraOutlineIcon } from "@parkschannel/ui";
import Link from "next/link";
import { useResolveParkPagePath } from "../path";
import { ParkImage, ParkImageSize } from "../ParkImage";
import { useAnalytics } from "../../../utils";
import { ImgixImage } from "../../ImgixImage";
export const ParkCardWithSticker = (param)=>{
    let { data  } = param;
    const { onButtonClick  } = useAnalytics();
    return /*#__PURE__*/ _jsx(Link, {
        href: useResolveParkPagePath(data.slug),
        onClick: ()=>onButtonClick("goToParkPage"),
        children: /*#__PURE__*/ _jsxs("article", {
            className: classNames("min-h-[328px] relative p-3 bg-white rounded-xl w-full min-w-[344px] grow drop-shadow hover:shadow-lg group transition-all duration-200 cursor-pointer"),
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: classNames("relative w-full rounded-xl overflow-hidden bg-neutral-100 h-[142px]"),
                    children: [
                        data.backgroundKey ? /*#__PURE__*/ _jsx(ParkImage, {
                            src: data.backgroundKey,
                            alt: data.fullName,
                            size: ParkImageSize.Thumbnail,
                            className: "object-cover group-hover:scale-110 transition",
                            fill: true
                        }) : /*#__PURE__*/ _jsx(SimpleImage, {
                            src: "/media/default-park-background.webp",
                            alt: "Park cover",
                            fill: true,
                            className: "object-cover group-hover:scale-110 transition"
                        }),
                        data.stickerKey ? /*#__PURE__*/ _jsx("div", {
                            className: "absolute bottom-3 left-3 w-[58px] h-[58px]",
                            children: /*#__PURE__*/ _jsx(ImgixImage, {
                                src: data.stickerKey,
                                alt: data.name,
                                fill: true,
                                className: "object-contain"
                            })
                        }) : null
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "relative py-2 lg:pt-3",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "w-full flex gap-2 justify-between",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "w-full max-w-[80%]",
                                    children: [
                                        /*#__PURE__*/ _jsx(Typography, {
                                            component: "h3",
                                            variant: "h4",
                                            className: "line-clamp-1 text-neutral-900 mt-1 lg:!leading-[26px]",
                                            children: data.name
                                        }),
                                        /*#__PURE__*/ _jsx("ul", {
                                            className: "w-full line-clamp-1 grow -mt-[2px]",
                                            children: data.states.map((state)=>/*#__PURE__*/ _jsx("li", {
                                                    className: "relative mr-3 inline-block text-xs text-neutral-500 before:absolute before:top-[5%] before:-left-[8px] before:content-['.'] before:text-neutral-200 before:text-2xl before:leading-[1px] first:before:content-none",
                                                    children: state
                                                }, state))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "w-12 h-12 flex justify-center items-center shadow-md rounded-xl text-neutral-400 group-hover:text-white group-hover:shadow-lg group-hover:bg-gradient-to-r group-hover:from-primary-500 group-hover:to-primary-600",
                                    children: /*#__PURE__*/ _jsx(ArrowRight, {
                                        className: "w-6 h-6"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: "bodyBase",
                            className: "line-clamp-3 text-neutral-500 min-h-[48px] mt-2 lg:line-clamp-3 lg:min-h-[54px]",
                            children: data.description
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "mt-3 flex gap-3 items-center",
                            children: [
                                !!data.videosCount && /*#__PURE__*/ _jsxs(Typography, {
                                    variant: "bodySmall",
                                    className: "text-neutral-500 flex gap-1 items-center",
                                    children: [
                                        /*#__PURE__*/ _jsx(VideoCameraOutlineIcon, {
                                            className: "text-neutral-500 w-[14px] h-[14px]"
                                        }),
                                        data.videosCount,
                                        " videos"
                                    ]
                                }),
                                !!data.creatorsCount && /*#__PURE__*/ _jsxs(Typography, {
                                    variant: "bodySmall",
                                    className: "text-neutral-500 flex gap-1 items-center",
                                    children: [
                                        /*#__PURE__*/ _jsx(UserIcon, {
                                            className: "text-neutral-500 w-[12px] h-[12px]"
                                        }),
                                        data.creatorsCount,
                                        " creators"
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
